/* ============================================================
   VELOURIA — PDP behaviour
   1) Live "Order within Xh Ym for free delivery by <date>" line
   2) Sticky mobile add-to-cart bar (reveal on scroll, proxies real ATC)
   ============================================================ */
(function () {
  'use strict';

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function fmtDate(d) {
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  // Add `days` business days (skip Sat/Sun) to a date
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function initDelivery(el) {
    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    var minDays = parseInt(el.getAttribute('data-min-days'), 10) || 3;
    var maxDays = parseInt(el.getAttribute('data-max-days'), 10) || 5;
    if (isNaN(cutoffHour)) cutoffHour = 17;
    var template = el.textContent.trim() ||
      'Order within {countdown} for free delivery by {date}';

    function render() {
      var now = new Date();
      var cutoff = new Date(now.getTime());
      cutoff.setHours(cutoffHour, 0, 0, 0);

      var beforeCutoff = now < cutoff;
      // delivery window is measured from today if before cutoff, else from tomorrow
      var base = new Date(now.getTime());
      if (!beforeCutoff) base.setDate(base.getDate() + 1);

      var minDate = addBusinessDays(base, minDays - 1 < 0 ? 0 : minDays - 1);
      var maxDate = addBusinessDays(base, maxDays - 1 < 0 ? 0 : maxDays - 1);

      var countdown;
      if (beforeCutoff) {
        var ms = cutoff - now;
        var h = Math.floor(ms / 3600000);
        var m = Math.floor((ms % 3600000) / 60000);
        if (h >= 1) {
          countdown = h + (h === 1 ? ' hour' : ' hours');
          if (m > 0) countdown += ' ' + m + ' min';
        } else {
          countdown = m + (m === 1 ? ' minute' : ' minutes');
        }
      } else {
        countdown = 'tomorrow';
      }

      var dateStr = fmtDate(minDate);
      if (maxDate.getTime() !== minDate.getTime()) {
        // same month: "Fri, Jun 5–7" style stays simple → just show the latest reliable date
        dateStr = fmtDate(maxDate);
      }

      var html = template
        .replace('{countdown}', '<span class="vlr-deliver__g">' + countdown + '</span>')
        .replace('{date}', '<b>' + dateStr + '</b>');
      el.innerHTML = html;
    }

    render();
    // refresh each minute so the countdown stays live
    setInterval(render, 60000);
  }

  function initSticky() {
    var bar = document.querySelector('[data-vlr-sticky]');
    if (!bar) return;
    var realBtn = document.querySelector('.vlr-bb .product-form__submit');
    var trigger = document.querySelector('.vlr-bb__head');
    var atcRow = document.querySelector('.vlr-bb .product-form__buttons');

    var stickyBtn = bar.querySelector('[data-vlr-sticky-atc]');
    if (stickyBtn && realBtn) {
      stickyBtn.addEventListener('click', function () {
        realBtn.click();
      });
    }

    if (!('IntersectionObserver' in window) || !trigger) {
      bar.classList.add('is-visible');
      return;
    }

    // Show the sticky bar once the main ATC scrolls out of view
    var watch = atcRow || trigger;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          bar.setAttribute('aria-hidden', 'true');
        } else if (entry.boundingClientRect.top < 0) {
          bar.classList.add('is-visible');
          bar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0 });
    io.observe(watch);
  }

  function init() {
    document.querySelectorAll('[data-vlr-delivery]').forEach(initDelivery);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
